import { styled } from "@mui/material/styles";
import Typography from "@bmi-digital/components/typography";
import Button from "@bmi-digital/components/button";
import { iconButtonClasses } from "@bmi-digital/components/icon-button";
import IconButton from "@bmi-digital/components/icon-button";
import Popover from "@mui/material/Popover";
import { paperClasses } from "@mui/material/Paper";
import BrandLogo from "../../BrandLogo";

export const SubHeaderWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.colours.pearl,
  padding: "18px 30px",
  display: "flex",
  justifyContent: "space-between",
  gap: "16px",

  [theme.breakpoints.down("md")]: {
    padding: "12px 18px",
    flexDirection: "column",
    gap: 0
  }
}));

export const StyledBrandLogo = styled(BrandLogo)(({ theme }) => ({
  minWidth: "60px",

  [theme.breakpoints.down("md")]: {
    height: "40px",
    marginBottom: "12px",
    minWidth: "40px"
  }
}));

export const SubHeaderContent = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  maxWidth: "50%",

  "&:last-of-type": {
    marginLeft: "40px",
    maxWidth: "calc(50% - 40px)"
  },

  [`&& .${iconButtonClasses.root}`]: {
    margin: "0 0 0 12px"
  },

  [theme.breakpoints.down("md")]: {
    maxWidth: "unset",
    "&:first-of-type": {
      flexDirection: "column",
      alignItems: "start",
      marginBottom: "12px"
    },

    "&:last-of-type": {
      marginLeft: 0,
      maxWidth: "unset"
    }
  }
}));

export const TileInformationBlock = styled("div")(({ theme }) => ({
  marginLeft: "40px",

  [theme.breakpoints.down("md")]: {
    marginLeft: 0
  }
}));

export const TileColour = styled(Typography)(({ theme }) => ({
  color: theme.colours.slate,
  marginTop: "6px"
}));

export const StyledShareButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    [`&.${iconButtonClasses.medium}`]: {
      width: "42px",
      height: "42px",
      fontSize: "1rem",
      svg: {
        fontSize: "1rem"
      }
    }
  }
}));

export const StyledReadMoreButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "42px"
  }
}));

export const StyledPopover = styled(Popover)({
  [`& .${paperClasses.root}`]: { padding: "0 16px" }
});
